import AddIcon from "@mui/icons-material/Add";
import {
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
  Zoom,
} from "@mui/material";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { connect, useStore } from "react-redux";
import { makeStyles } from "tss-react/mui";
import {
  createCounter,
  createCounterType,
  deleteCounter,
  getCounterTypes,
  updateCounter,
  getUnits,
} from "../../../../actions/counters";
import { getSingleMachine } from "../../../../actions/machines";
// import { getUnits } from "../../../../shared-functions/units";
import { canUserPerformAction } from "../../../../shared-functions/userrights";
import { Theme247 } from "../../../../styles/Theme247";
import { ApplyStyle as _s } from "../../../../utils/ApplyStyle";
import { EmptyState } from "../../EmptyStat";
import styles from "./counters.module.css";

import { ReactComponent as SettingSvg } from "../../../../assets/Setting.svg";

import { ReactComponent as BlueEditSvg } from "../../../../assets/BlueEdit.svg";

// Styles for the modal component
const useStyles = makeStyles()((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    // border: '2px solid #000',
    borderRadius: "5px",
    boxShadow: theme.shadows[5],
    padding: "20px 24px 20px 24px",
    width: "398px",
    height: "auto",
  },
}));

export default connect(
  ({ i18n, machines, counterTypes, profile,units }) => ({
    i18n,
    machines,
    counterTypes,
    profile,
    units,
  }),
  {
    updateCounter,
    getSingleMachine,
    getCounterTypes,
    createCounter,
    createCounterType,
    deleteCounter,
    getUnits,
  }
)((props) => {
  const { units } = props;
  const i18n = props.i18n;
  const store = useStore().getState();

  const [counterValue, setCounterValue] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [value, setValue] = useState();
  const [itemsPerPage] = useState(10);
  const [iconValue, setIconValue] = useState();
  const [clickedIndex, setClickedIndex] = useState(-1);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState();

  const [selected, setSelected] = useState([]);

  const [editingItemId, setEditingItemId] = useState(null);
  const textFieldRefs = useRef({});

  const { machines, counterTypes } = props;
  // Calculate the index of the first and last items to display on the current page
  const lastIndex = currentPage * itemsPerPage;
  const firstIndex = lastIndex - itemsPerPage;

  // Slice the items array to get only the items for the current page
  var displayedItems =
    machines?.equipment?.hascounter &&
    machines?.equipment?.hascounter.length > 0 &&
    machines?.equipment?.hascounter.map((item) => ({
      ...item,
      isEditing: false,
    }));

  // Calculate the total number of pages needed to display all the items
  const totalPages = Math.ceil(
    machines?.equipment?.hascounter &&
      machines?.equipment?.hascounter.length > 0 &&
      machines?.equipment?.hascounter?.length / itemsPerPage
  );

  const [items, setItems] = useState([]);
  const [itemValues, setItemValues] = useState(
    items && items.map((item) => ({ value: item.value }))
  );
  // Function to handle when the user clicks on a page number
  function handlePageClick(page) {
    setCurrentPage(page);
  }

  /* hooks */

  const getDateFromTimestamp = (unixTimeStamp) => {
    if (unixTimeStamp != undefined) {
      let date = new Date(unixTimeStamp);
      return (
        (date.getDate() <= 9 ? "0" + date.getDate() : date.getDate()) +
        "." +
        (date.getMonth() + 1 <= 9
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) +
        "." +
        date.getFullYear()
      );
    } else {
      return "";
    }
  };

  function handleEditClick(item) {
    const updatedItems = [...items];
    const index = updatedItems.findIndex(
      (i) => i?.counter?.nodeid === item?.counter?.nodeid
    );
    updatedItems[index].isEditing = true;
    setItems(updatedItems);
  }

  function handleSaveClick(item) {
    const updatedItems = [...items];
    const index = updatedItems.findIndex(
      (i) => i?.counter?.nodeid === item?.counter?.nodeid
    );

    if (itemValues[index] && itemValues[index].value !== undefined) {
      itemValues[index].value = itemValues[index].value.replace(/\./g, "");
      itemValues[index].value = itemValues[index].value.replace(/\,/g, ".");
      updatedItems[index].isEditing = false;
      setItems(updatedItems);
      props.updateCounter({
        lang: store.language,
        values: [Number(itemValues[index].value), Date.now()],
        nodeid: updatedItems[index].counter?.nodeid,
      });
      setTimeout(function() {
        props.getSingleMachine(machines?.equipment?.nodeid);
      }, 2000);
    } else {
      updatedItems[index].isEditing = false;
      setItems(updatedItems);
    }
  }

  useEffect(() => {
    if (editingItemId !== null) {
      textFieldRefs.current[editingItemId].focus();
    }
  }, [editingItemId]);

  const handleValueChange = (index, value) => {
    if (index !== undefined && value !== undefined) {
      const newValues = [...itemValues];
      if (newValues.length > 0) {
        // Remove all non-digit and non-comma characters
        let tempValue = value.replace(/[^\d,]/g, "");
        if (value.startsWith(",")) {
          tempValue = "0,";
        }

        // Replace multiple commas with a single comma
        tempValue = tempValue.replace(/,{2,}/g, ",");
        tempValue = tempValue.replace(/(,[^,]*),/g, "$1");

        // Split the value into whole and decimal parts
        const parts = tempValue.split(",");

        // Format the whole part by adding thousands separator
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        // Join the parts with a comma
        tempValue = parts.join(",");
        newValues[index].value = tempValue;

        setItemValues(newValues);
      }
    }
  };

  const { classes } = useStyles();
  const [open, setOpen] = useState(false);
  const [counterTypeValue, setCounterTypeValue] = useState();
  const [counterTypeUnitValue, setCounterTypeUnitValue] = useState();
  const [counterNameValue, setCounterNameValue] = useState();
  const [counterTypeNameValue, setCounterTypeNameValue] = useState();
  const [viewCounter, setViewCounter] = useState(false);
  const [viewCounterType, setViewCounterType] = useState(false);
  const [rowEdit, setRowEdit] = useState(false);
  const [nodeid, setNodeid] = useState();
  const [previousCounterTypeNodeId, setPreviousCounterTypeNodeId] = useState();

  const handleOpen = () => {
    setOpen(true);
    setCounterValue("");
    setViewCounter(true);
    setViewCounterType(false);
  };

  const handleEdit = (nodeid, counterTypeNodeId, counterName, counterValue) => {
    /* console.log(counterValue,"==== counterValue"); */
    let tempCounter = counterValue?.replace(".", "");
    // tempCounter = tempCounter.replace(",",".");

    setRowEdit(true);
    setNodeid(nodeid);
    setCounterTypeValue(counterTypeNodeId);
    setCounterNameValue(counterName);
    setOpen(true);
    setViewCounter(true);
    setViewCounterType(false);
    setCounterValue(tempCounter);
  };

  const handleClose = () => {
    setOpen(false);
    setViewCounterType(false);
    setViewCounter(false);
    setRowEdit(false);
    setCounterTypeValue("");
    setCounterNameValue("");
    setCounterTypeNameValue("");
    setCounterTypeUnitValue();
  };

  const handleCounterTypes = (event) => {
    setCounterTypeNameValue("");
    setCounterTypeUnitValue();

    if (event.target.value === -1) {
      setViewCounterType(true);
      setViewCounter(false);
      setCounterTypeValue(event.target.value);
    } else {
      setViewCounterType(false);
      setViewCounter(true);
      setPreviousCounterTypeNodeId(counterTypeValue);
      setCounterTypeValue(event.target.value);
    }
  };

  const handleCounterTypeUnits = (event) => {
    const filterOption = units.filter((o) => o.unitId === event.target.value);
    if (filterOption && filterOption.length > 0) {
      setCounterTypeUnitValue({
        unit: {
          unitId: event.target.value,
          namespace: filterOption[0].namespace,
        },
      });
    }
  };

  const getUnitName = (countertype) => {
    const unitId =
      countertype?.unit?.unitid !== undefined
        ? countertype?.unit?.unitid
        : countertype?.unit?.unit?.unitId;
    const filterOption = units.filter((o) => o.unitId === unitId);
    if (filterOption && filterOption.length > 0) {
      return filterOption[0]?.displayName?.plural[store.language];
    } else {
      return unitId;
    }
  };

  const handleCounterName = (event) => {
    setCounterNameValue(event.target.value);
  };

  const handleCounterValueChange = (event) => {
    let inputValue = event.target.value;
    // Allow only numbers, a single decimal point, and a single comma
    const sanitizedValue = inputValue.replace(/[^0-9.,]/g, "");

    // Ensure only one decimal point is present
    const decimalCount = sanitizedValue.split(".").length - 1;
    if (decimalCount > 1) return;

    // Ensure only one comma is present
    const commaCount = sanitizedValue.split(",").length - 1;
    if (commaCount > 1) return;
    setCounterValue(event.target.value);
  };

  const handleCounterTypeName = (event) => {
    setCounterTypeNameValue(event.target.value);
  };

  const handleSubmit = () => {
    const sanitizedValue = counterValue.replace(/,/g, ".");
    if (rowEdit) {
      props.updateCounter({
        lang: store.language,
        name: counterNameValue,
        values: [+sanitizedValue, Date.now()],
        counterTypeNodeId: counterTypeValue,
        nodeid: nodeid,
        previousCounterTypeNodeId:
          previousCounterTypeNodeId === undefined
            ? counterTypeValue
            : previousCounterTypeNodeId,
      });
    } else if (counterTypeValue === -1) {
      if (counterNameValue) {
        props.createCounterType({
          lang: store.language,
          name: counterTypeNameValue,
          unit: counterTypeUnitValue,
          counter: {
            lang: store.language,
            name: counterNameValue,
            counterTypeNodeId: undefined,
            equipmentNodeId: machines?.equipment?.nodeid,
            values: [+sanitizedValue, Date.now()],
          },
        });
      } else {
        props.createCounterType({
          lang: store.language,
          name: counterTypeNameValue,
          unit: counterTypeUnitValue,
        });
      }
    } else {
      props.createCounter({
        lang: store.language,
        name: counterNameValue,
        counterTypeNodeId: counterTypeValue,
        equipmentNodeId: machines?.equipment?.nodeid,
        values: [+sanitizedValue, Date.now()],
      });
    }

    setTimeout(function() {
      props.getSingleMachine(machines?.equipment?.nodeid);
      props.getCounterTypes({}, "COUNTER_TYPES");
    }, 2000);

    setRowEdit(false);
    setCounterTypeValue("");
    setCounterNameValue("");
    setCounterTypeNameValue("");
    setCounterTypeUnitValue();

    setOpen(false);
  };

  const handleDelete = () => {
    props.deleteCounter({ nodeid: nodeid });
    setTimeout(function() {
      props.getSingleMachine(machines?.equipment?.nodeid);
    }, 2000);
    setCounterTypeValue("");
    setCounterNameValue("");
    setRowEdit(false);
    setOpen(false);
  };

  const handleSubmitCT = () => {
    setTimeout(function() {
      props.getSingleMachine(machines?.equipment?.nodeid);
      props.getCounterTypes({}, "COUNTER_TYPES");
    }, 2000);
    setCounterTypeNameValue("");
    setCounterTypeUnitValue("");
    setCounterTypeValue("");
    setCounterNameValue("");
    setOpen(false);
  };

  const handleRowEdit = () => {
    if (rowEdit) {
      setRowEdit(false);
    } else {
      setRowEdit(true);
    }
  };
  /* hooks */

  useEffect(() => {
    props.getUnits("UNITS")
    props.getCounterTypes({}, "COUNTER_TYPES");
    setItems(
      displayedItems &&
        displayedItems.map((item) => ({ ...item, isEditing: false }))
    );
  }, []);

  useEffect(() => {
    setItems(
      machines?.equipment?.hascounter &&
        machines?.equipment?.hascounter.length > 0 &&
        machines?.equipment?.hascounter.map((item) => ({
          ...item,
          isEditing: false,
        }))
    );
  }, [machines]);

  useEffect(() => {
    if (items && items.length > 0) {
      setItemValues(items && items.map((item) => ({ value: item.value })));
    }
  }, [items]);

  let allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight"];

  const substring = (string, maxLength) => {
    return string.length > maxLength
      ? string.slice(0, maxLength) + "..."
      : string;
  };

  const myClasses = {
    inputField: _s(Theme247.inputField),
    sectionButtonFooter: _s(Theme247.sectionButtonFooter),
    sectionHeader: _s(Theme247.sectionHeader),
  };

  function EnhancedTableHead(props) {
    const headCells = [
      {
        id: "1",
        numeric: false,
        disablePadding: false,
        sortIcon: "show",
        label: i18n.counter_table_name,
        color: "var(--color-primary)",
      },
      {
        id: "2",
        numeric: false,
        disablePadding: false,
        label: i18n.counter_table_value,
        color: "var(--color-primary)",
      },
      {
        id: "3",
        numeric: false,
        disablePadding: false,
        label: i18n.counter_table_updated,
        color: "var(--color-primary)",
      },
      {
        id: "4",
        numeric: false,
        disablePadding: false,
        label: "",
        color: "var(--color-primary)",
      },
    ];

    const {
      classes,
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              style={{ color: headCell.color, backgroundColor: "white" }}
            >
              {headCell.label}
              {/* <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >

                            </TableSortLabel> */}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    // orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = props.machines.equipment.hasmaintenancetask.map(
        (n) => n.maintenancetask.startingfrom
      );
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  return (
    <>
      <div>
        <Modal
          className={classes.modal}
          open={open}
          onClose={handleClose}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          {/* counter view  */}
          <Zoom in={open}>
            <div className={classes.paper}>
              <div className="counter-simple-modal-title">
                {i18n.counter_modal_title}
              </div>
              <Grid item xs={12}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel>{i18n.counter_Type}</InputLabel>

                  <Select
                    value={counterTypeValue}
                    onChange={handleCounterTypes}
                    label={i18n.counter_Type}
                    // style={{ width: 265 }}
                    variant="outlined"
                    disabled={rowEdit ? true : false}
                  >
                    <MenuItem value={-1}>
                    {i18n.counter_new_type_placeholder}
                    </MenuItem>
                    {counterTypes.map((ct, k) => {
                      return (
                        <MenuItem
                          key={ct?.countertype?.nodeid}
                          value={ct?.countertype?.nodeid}
                        >
                          {ct?.countertype?.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <br></br>

                  <div style={{ display: viewCounterType ? "block" : "none" }}>
                    <TextField
                      type="text"
                      value={counterTypeNameValue}
                      onChange={handleCounterTypeName}
                      label={i18n.counter_type_name_label}
                      variant="outlined"
                      fullWidth
                    />
                    <br />
                    <br />

                    <FormControl variant="outlined" fullWidth>
                      <InputLabel>Einheit</InputLabel>
                      <Select
                        value={counterTypeUnitValue}
                        onChange={handleCounterTypeUnits}
                        label={"Einheit"}
                        variant="outlined"
                      >
                        {units.map((option) => (
                          <MenuItem key={option.unitId} value={option.unitId}>
                            {option?.displayName?.plural[store.language]}
                            {/* {option.unitId} */}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <br />
                    <br />
                    <Divider color="#c9c3c3" />
                    <br />
                  </div>

                  <TextField
                    type="text"
                    value={counterNameValue}
                    onChange={handleCounterName}
                    label={i18n.counter_name_label}
                    variant="outlined"
                    disabled={rowEdit ? true : false}
                  />
                  <br></br>
                  <TextField
                    type="text"
                    value={counterValue}
                    onChange={handleCounterValueChange}
                    label={i18n.counter_value_label}
                    variant="outlined"
                  />
                  <br />

                  {canUserPerformAction(
                    props.profile?.features?.["equipment.counter"],
                    "delete"
                  ) && (
                    <>
                      {" "}
                      {rowEdit ? (
                        <Button
                          variant="outlined"
                          startIcon={
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_3216_5272"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="18"
                                height="18"
                              >
                                <rect width="18" height="18" fill="#D9D9D9" />
                              </mask>
                              <g mask="url(#mask0_3216_5272)">
                                <path
                                  d="M5.25 15.75C4.8375 15.75 4.4845 15.6033 4.191 15.3097C3.897 15.0157 3.75 14.6625 3.75 14.25V4.5C3.5375 4.5 3.35925 4.42825 3.21525 4.28475C3.07175 4.14075 3 3.9625 3 3.75C3 3.5375 3.07175 3.35925 3.21525 3.21525C3.35925 3.07175 3.5375 3 3.75 3H6.75C6.75 2.7875 6.822 2.60925 6.966 2.46525C7.1095 2.32175 7.2875 2.25 7.5 2.25H10.5C10.7125 2.25 10.8908 2.32175 11.0347 2.46525C11.1783 2.60925 11.25 2.7875 11.25 3H14.25C14.4625 3 14.6405 3.07175 14.784 3.21525C14.928 3.35925 15 3.5375 15 3.75C15 3.9625 14.928 4.14075 14.784 4.28475C14.6405 4.42825 14.4625 4.5 14.25 4.5V14.25C14.25 14.6625 14.1033 15.0157 13.8097 15.3097C13.5157 15.6033 13.1625 15.75 12.75 15.75H5.25ZM5.25 4.5V14.25H12.75V4.5H5.25ZM9 10.425L10.425 11.85C10.575 11.9875 10.7533 12.0563 10.9598 12.0563C11.1657 12.0563 11.3375 11.9875 11.475 11.85C11.625 11.7 11.7 11.5217 11.7 11.3153C11.7 11.1093 11.625 10.9375 11.475 10.8L10.05 9.375L11.475 7.95C11.625 7.8 11.7 7.62175 11.7 7.41525C11.7 7.20925 11.625 7.0375 11.475 6.9C11.3375 6.75 11.1657 6.675 10.9598 6.675C10.7533 6.675 10.575 6.75 10.425 6.9L9 8.325L7.575 6.9C7.4375 6.75 7.26575 6.675 7.05975 6.675C6.85325 6.675 6.675 6.75 6.525 6.9C6.3875 7.0375 6.31875 7.20925 6.31875 7.41525C6.31875 7.62175 6.3875 7.8 6.525 7.95L7.95 9.375L6.525 10.8C6.3875 10.9375 6.31875 11.1093 6.31875 11.3153C6.31875 11.5217 6.3875 11.7 6.525 11.85C6.675 11.9875 6.85325 12.0563 7.05975 12.0563C7.26575 12.0563 7.4375 11.9875 7.575 11.85L9 10.425Z"
                                  fill="#FF3D00"
                                />
                              </g>
                            </svg>
                          }
                          color="error"
                          onClick={handleDelete}
                          style={{
                            width: "107px",
                            display:
                              counterTypeValue ===
                              "247fn://247uptime.io/f25642d6-8b33-42f7-a635-d2a78f056c89"
                                ? "none"
                                : "flex",
                          }}
                        >
                          {i18n.delete}
                        </Button>
                      ) : (
                        ""
                      )}
                      <br />
                    </>
                  )}
                  <Divider color="#c9c3c3" />
                  <br />
                </FormControl>
              </Grid>
              <Grid
                item
                xs={12}
                className={myClasses.sectionButtonFooter}
                style={{ justifyContent: "flex-end" }}
              >
                <Button
                  variant="outlined"
                  onClick={handleClose}
                  style={{
                    minWidth: "107px",
                    border: "none",
                    color: "rgba(56, 116, 141, 1)",
                  }}
                >
                  {i18n.button_cancel}
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  style={{ minWidth: "118px" }}
                >
                  {i18n.save}
                </Button>

                {/* <Button variant="contained" color="primary" onClick={handleClose}>
                        
                        </Button> */}
              </Grid>
            </div>

            {/* counter type view */}
          </Zoom>
        </Modal>
      </div>

      {items?.length > 0 ? (
        <>
          <div className={styles.Container}>
            {/* <div className={myClasses.sectionHeader}>
                                    <Typography variant="h1">{i18n.tab_counters}</Typography>
                                </div> */}
            {/* <Button onClick={handleRowEdit} startIcon={rowEdit ? <Create /> : ""} variant="outlined">{i18n.edit}</Button> */}
            <div
              className="MO_maintenance"
              style={{ justifyContent: "start", marginBottom: "12px" }}
            >
              <div
                className={myClasses.sectionHeader}
                style={{ margin: 0, alignItems: "center" }}
              >
                <Typography
                  variant="h1"
                  style={{ margin: 0, textTransform: "capitalize" }}
                >
                  {i18n.tab_counters}
                </Typography>
              </div>

              <div>
                {canUserPerformAction(
                  props.profile?.features?.["equipment.counter"],
                  "create"
                ) && (
                  <Button
                    style={{ marginLeft: "20px" }}
                    onClick={handleOpen}
                    startIcon={<AddIcon />}
                    variant="contained"
                    color="primary"
                  >
                    {i18n.add_new_counter}{" "}
                  </Button>
                )}
              </div>
            </div>
            <div className="MO_maintenance_desc" style={{ width: "100%" }}>
              {i18n.counter_desc}
            </div>
            <TableContainer
              sx={{ maxHeight: 350, marginTop: "23px", overflow: "auto" }}
            >
              <Table stickyHeader className="countersTable">
                <EnhancedTableHead
                  classes={classes}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={
                    props.machines &&
                    props.machines?.equipment?.hasmaintenancetask &&
                    props.machines?.equipment?.hasmaintenancetask.length
                  }
                />
                <TableBody>
                  {items &&
                    items.map((counter, k) => {
                      return (
                        <TableRow key={k}>
                          <TableCell>{counter?.counter?.name}</TableCell>
                          <TableCell
                            sx={{ display: "flex", alignItems: "flex-start" }}
                          >
                            <span
                              className="item_text"
                              style={{ display: "flex" }}
                            >
                              {canUserPerformAction(
                                props.profile?.features?.["equipment.counter"],
                                "update"
                              ) && (
                                <div
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleEdit(
                                      counter?.counter?.nodeid,
                                      counter?.counter?.hascountertype[0]
                                        ?.countertype?.nodeid,
                                      counter?.counter?.name,
                                      counter?.counter?.values &&
                                        counter?.counter?.values.length === 0
                                        ? 0
                                        : counter?.counter?.values[
                                            counter?.counter?.values?.length - 1
                                          ] &&
                                            counter?.counter?.values[
                                              counter?.counter?.values?.length -
                                                1
                                            ][0]?.toLocaleString(
                                              store.language === "de"
                                                ? store.language + "-DE"
                                                : store.language + "-US",
                                              {
                                                useGrouping: true,
                                                minimumFractionDigits: 0,
                                                currency: undefined,
                                              }
                                            )
                                    )
                                  }
                                >
                                  <BlueEditSvg />
                                </div>
                              )}
                              <span style={{ marginLeft: "8px" }}>
                                {counter?.counter?.values &&
                                counter?.counter?.values.length === 0
                                  ? 0
                                  : counter?.counter?.values[
                                      counter?.counter?.values?.length - 1
                                    ] &&
                                    counter?.counter?.values[
                                      counter?.counter?.values?.length - 1
                                    ][0]?.toLocaleString(
                                      store.language === "de"
                                        ? store.language + "-DE"
                                        : store.language + "-US",
                                      {
                                        useGrouping: true,
                                        minimumFractionDigits: 0,
                                        currency: undefined,
                                      }
                                    )}
                              </span>
                            </span>{" "}
                            <sapn className="item_subtext">
                              {getUnitName(
                                counter?.counter?.hascountertype[0]?.countertype
                              )}
                            </sapn>
                          </TableCell>
                          <TableCell>
                            {getDateFromTimestamp(
                              counter?.counter?.values[
                                counter?.counter?.values?.length - 1
                              ] &&
                                counter?.counter?.values[
                                  counter?.counter?.values?.length - 1
                                ][1]
                            )}
                          </TableCell>
                          <TableCell>
                            <div
                              style={{ cursor: "pointer", textAlign: "end" }}
                              onClick={() =>
                                handleEdit(
                                  counter?.counter?.nodeid,
                                  counter?.counter?.hascountertype[0]
                                    ?.countertype?.nodeid,
                                  counter?.counter?.name,
                                  counter?.counter?.values &&
                                    counter?.counter?.values.length === 0
                                    ? 0
                                    : counter?.counter?.values[
                                        counter?.counter?.values?.length - 1
                                      ] &&
                                        counter?.counter?.values[
                                          counter?.counter?.values?.length - 1
                                        ][0]?.toLocaleString(
                                          store.language === "de"
                                            ? store.language + "-DE"
                                            : store.language + "-US",
                                          {
                                            useGrouping: true,
                                            minimumFractionDigits: 0,
                                            currency: undefined,
                                          }
                                        )
                                )
                              }
                            >
                              <SettingSvg />
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>

            {/* <div style={{ display: "flex", justifyContent: "center" }}>
                  
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                        <button
                            key={page}
                            onClick={() => handlePageClick(page)}
                            style={{
                                margin: "0 5px",
                                fontWeight: currentPage === page ? "bold" : "normal"
                            }}
                        >
                            {page}
                        </button>
                    ))}
                </div> */}
            {/* {canUserPerformAction(props.profile?.features?.["equipment.counter"], "create") &&
                                <Button onClick={handleOpen} startIcon={<AddIcon />} variant="outlined">{i18n.add_new_counter}</Button>
                            } */}
          </div>
        </>
      ) : (
        <EmptyState
          heading={i18n.counters_empty_heading}
          title={i18n.counters_empty_title}
          description={i18n.counters_empty_description}
          icon={
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_2299_36246"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_2299_36246)">
                <path
                  d="M15 16H18C18.2833 16 18.5208 15.9042 18.7125 15.7125C18.9042 15.5208 19 15.2833 19 15V9C19 8.71667 18.9042 8.47917 18.7125 8.2875C18.5208 8.09583 18.2833 8 18 8H15C14.7167 8 14.4792 8.09583 14.2875 8.2875C14.0958 8.47917 14 8.71667 14 9V15C14 15.2833 14.0958 15.5208 14.2875 15.7125C14.4792 15.9042 14.7167 16 15 16ZM16 14V10H17V14H16ZM9 16H12C12.2833 16 12.5208 15.9042 12.7125 15.7125C12.9042 15.5208 13 15.2833 13 15V9C13 8.71667 12.9042 8.47917 12.7125 8.2875C12.5208 8.09583 12.2833 8 12 8H9C8.71667 8 8.47917 8.09583 8.2875 8.2875C8.09583 8.47917 8 8.71667 8 9V15C8 15.2833 8.09583 15.5208 8.2875 15.7125C8.47917 15.9042 8.71667 16 9 16ZM10 14V10H11V14H10ZM6 16C6.28333 16 6.52083 15.9042 6.7125 15.7125C6.90417 15.5208 7 15.2833 7 15V9C7 8.71667 6.90417 8.47917 6.7125 8.2875C6.52083 8.09583 6.28333 8 6 8C5.71667 8 5.47917 8.09583 5.2875 8.2875C5.09583 8.47917 5 8.71667 5 9V15C5 15.2833 5.09583 15.5208 5.2875 15.7125C5.47917 15.9042 5.71667 16 6 16ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM4 18H20V6H4V18Z"
                  fill="black"
                  fillOpacity="0.5"
                />
              </g>
            </svg>
          }
          hasButton
          button={
            <div style={{ marginTop: "20px" }}>
              {canUserPerformAction(
                props.profile?.features?.["equipment.counter"],
                "create"
              ) && (
                <Button
                  onClick={handleOpen}
                  startIcon={<AddIcon />}
                  variant="contained"
                  color="primary"
                >
                  {i18n.add_new_counter} {i18n.counters_title}
                </Button>
              )}
            </div>
          }
        />
      )}
    </>
  );
});
